import { FiUserCheck } from "react-icons/fi";

export default function Hunt({ job }) {
  return (
    <div className="w-full px-6 py-12">
      <div className="max-w-2xl mx-auto bg-white border border-gray-200 rounded-xl p-12 text-center">
        <div className="mx-auto w-12 h-12 rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center mb-4">
          <FiUserCheck className="w-6 h-6" />
        </div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Hunt</h2>
        <p className="text-sm text-gray-500">Coming soon — profiles submitted by headhunters will appear here.</p>
      </div>
    </div>
  );
}
